/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 draws three points in the plane.`)
};

const es_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 dibuja tres puntos en el plano.`)
};

const de_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 zeichnet drei Punkte in der Ebene.`)
};

const nl_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 tekent drie punten in het vlak.`)
};

const fr_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 dessine trois points dans le plan.`)
};

const it_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 disegna tre punti nel piano.`)
};

const pt_br2_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 desenha três pontos no plano.`)
};

const pt_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 desenha três pontos no plano.`)
};

const ja_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 で平面上に3つの点が描画されます。`)
};

const zh_scatter_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,2 / 2,4 / 3,3 在平面上绘制三个点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_ex1", locale)
	if (locale === "en") return en_scatter_ex1(inputs)
	if (locale === "es") return es_scatter_ex1(inputs)
	if (locale === "de") return de_scatter_ex1(inputs)
	if (locale === "nl") return nl_scatter_ex1(inputs)
	if (locale === "fr") return fr_scatter_ex1(inputs)
	if (locale === "it") return it_scatter_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_ex1(inputs)
	if (locale === "pt") return pt_scatter_ex1(inputs)
	if (locale === "ja") return ja_scatter_ex1(inputs)
	return zh_scatter_ex1(inputs)
};